import { TranslationKey } from './../../../../../../types/translation/TranslationKey';
import React from 'react';
import { t } from '../../../../../../types/translation/Translator';
import { countries } from '../../../../../../util/country';
import { Checkbox } from '../../../../../components/Checkbox';
import { DropdownSearchSelect } from '../../../../../components/Dropdown';
import { TextInput } from '../../../../../components/TextInput';
import { Feedback } from '../../../../../components/Feedback/feedback';
import { StockLocationInput } from '../../../../../../types/stock_location/stockLocation.input';

interface StockLocationFormProps {
  existing: Map<string, StockLocationInput>;
  stockLocation: StockLocationInput;
  setStockLocation: (stockLocation: StockLocationInput) => void;
}

export default function StockLocationForm({ existing, stockLocation, setStockLocation }: StockLocationFormProps) {
  return (
    <div className='grid gap-2'>
      <div className='grid grid-cols-2 gap-2'>
        <TextInput
          mandatory
          label={t(TranslationKey.name).singular.label}
          onChange={value => setStockLocation(stockLocation.withName(value))}
          placeholder={'Your stock location name'}
          value={stockLocation.name}
          feedback={value => {
            if (!value) return { type: Feedback.Type.error, text: 'Stock location name is required!' };
            const existingWithName = [...existing.values()].find(sl => sl.name === value && sl.id !== stockLocation.id);
            if (existingWithName) {
              return { type: Feedback.Type.error, text: 'Stock location with this name already exists!' };
            }
          }}
        />
        <TextInput
          label={t(TranslationKey.identifier).singular.label}
          onChange={value => setStockLocation(stockLocation.withIdentifier(value))}
          placeholder={'Ex: WH-001, LOC-12345, Aisle 4B'}
          value={stockLocation.identifier}
        />
      </div>
      <TextInput
        label={t(TranslationKey.addressLine1).singular.label}
        onChange={value => setStockLocation(stockLocation.withAddressLine1(value))}
        placeholder={'Street and number'}
        value={stockLocation.address?.addressLine1}
      />
      <TextInput
        label={t(TranslationKey.addressLine2).singular.label}
        onChange={value => setStockLocation(stockLocation.withAddressLine2(value))}
        placeholder={'Ex: building, building number or specific delivery instructions.'}
        value={stockLocation.address?.addressLine2}
      />
      <div className='grid grid-cols-2 gap-2'>
        <TextInput
          label={t(TranslationKey.postalCode).singular.label}
          onChange={value => setStockLocation(stockLocation.withPostalCode(value))}
          value={stockLocation.address?.postalCode}
        />
        <TextInput
          label={t(TranslationKey.city).singular.label}
          onChange={value => setStockLocation(stockLocation.withCity(value))}
          value={stockLocation.address?.city}
        />
      </div>
      <div className='grid grid-cols-2 gap-2'>
        <TextInput
          label={t(TranslationKey.region).singular.label}
          onChange={value => setStockLocation(stockLocation.withRegion(value))}
          value={stockLocation.address?.region}
        />
        <DropdownSearchSelect
          onSelect={value => setStockLocation(stockLocation.withCountryCode(value ? value.cca2 : undefined))}
          placeholder={'Select a country'}
          label={t(TranslationKey.country).singular.label}
          value={countries.find(c => c.cca2 === stockLocation.address?.countryCode)}
          items={countries}
          textBuilder={country => country.name.common}
        />
      </div>
      <Checkbox
        label={t(TranslationKey.mobileStockLocation).singular.label}
        value={stockLocation.mobile || false}
        onChange={value => setStockLocation(stockLocation.withMobile(value))}
      />
    </div>
  );
}
